import http from '../plugins/axios'

export const getPackingList = async (params) => {
  try {
    const response = await http.get('/api/v2/packing-list', { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const getDetailPackingList = async (packingId, params) => {
  try {
    const response = await http.get(`/api/v2/packing-list/${packingId}`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const addPackingList = async (payload) => {
  try {
    const response = await http.post(`/api/v2/packing-list`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updatePackingList = async (packingId, payload) => {
  try {
    const response = await http.put(`/api/v2/packing-list/${packingId}`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deletePackingList = async (packingId) => {
  try {
    const response = await http.delete(`/api/v2/packing-list/${packingId}`)
    return response.data
  } catch(error) {
    throw error
  }
}